import { DeliverySectionController } from './DeliverySectionController';
export const createDeliverySectionController = controllerParams => {
  return new DeliverySectionController(controllerParams);
};
//# sourceMappingURL=createDeliverySectionController.js.map